import { createDraftTransfer } from './createDraftTransfer';
import { toast } from 'react-toastify';
import { saveTransferDetails } from '../../../reducers/transfer/TransferActions';
import { singleUseAccountNumber } from '../../../utils/service/v2/api';
import {
  setAmount,
  setCity,
  setNotes,
  setOffice,
  setReAmount,
  setStateLocale,
  setStreet,
  setStreet2,
  setZip,
} from '../../../reducers/components/TransferDetails/FormActions';
import { setLoading } from '../../../reducers/utility/utilityActions';
import {
  emailFinancials,
  sendEmailReceipt,
  sendWireEmailReceipt,
} from '../../../utils/service/service_api';

/*
  This function handles the sumission of the wire transfer
  After successful submission, the user is routed to either the 
  wire info screen or the bank.

  -USED IN: TransferDetails.jsx
*/
export async function submitTransfer(
  event,
  saveTransfer,
  transfer_id,
  dispatch,
  createTransfer,
  realtorData,
  transferFeeConfigData,
  state,
  // destAccount,
  sourceBankAccount,
  creditTransferTypes,
  props,
  submissionProps,
  radioCheck,
  tenantId,
  status,
  method,
  fieldOffice,
) {
  event.preventDefault();

  //transfer object
  const newTransfer = {
    amount: submissionProps.amount,
    notes: submissionProps.notes,
    propertyAddress1: submissionProps.street,
    propertyAddress2: submissionProps.street2,
    propertyCity: submissionProps.city,
    purpose: radioCheck?.purpose,
    propertyState: submissionProps.stateLocale,
    propertyZipcode: submissionProps.zip,
  };

  //creates the data package for submission via createTransfer()
  const check = createDraftTransfer({
    props,
    // destAccount,
    state,
    newTransfer,
    creditTransferTypes,
    transferFeeConfigData,
    realtorData,
    status,
    method,
    office: fieldOffice,
  });

  //bank account has to be deleted from check. Otherwise 400 error
  delete check.sourceBankAccount;

  // conditional submission and routing logic
  if (radioCheck.method === 'ACH') {
    //a passed in transfer_id indicates an active transfer.
    if (transfer_id) {
      saveTransfer({ variables: { id: transfer_id, transfer: check } })
        .then((response) => {
          dispatch(saveTransferDetails({ ...check, tenant: props.tenant }));
          /*
            sends transferId to be able to navigate back and populate the fields with the
            transfer details
          */
          props.history.push('/create-account/step-select-account', {
            existingTransferId: transfer_id,
          });
        })
        .catch((err) => {
          toast.error(err.message);
          console.log(err, 'error');
        });
    } else {
      createTransfer({ variables: { transfer: check } })
        .then((response) => {
          dispatch(saveTransferDetails({ ...check, tenant: props.tenant }));

          props.history.push('/create-account/step-select-account', {
            existingTransferId: response?.data?.insertOneTransfer?._id,
          });
        })
        .catch((err) => {
          toast.error(err.message);
          console.log(err, 'error');
        });
    }
  } else {
    if (transfer_id) {
      saveTransfer({
        variables: {
          id: transfer_id,
          transfer: { ...check, status: 'awaiting wire' },
        },
      })
        .then(async (response) => {
          dispatch(
            saveTransferDetails({
              ...check,
              tenant: props.tenant,
              status: 'awaiting wire',
            }),
          );
          //email package
          // const data = {
          //   transfer: { ...check, name: 'Client Transfer', status: 'awaiting wire' },
          //   TRANSFER_GUID: transfer_id,
          // };
          //send email
          // const res = await emailFinancials(data);
          // console.log(res)
          //clear form state
          dispatch(setAmount(null));
          dispatch(setReAmount(null));
          dispatch(setCity(null));
          dispatch(setStateLocale(null));
          dispatch(setZip(null));
          dispatch(setStreet(null));
          dispatch(setStreet2(null));
          dispatch(setNotes(null));
          dispatch(setLoading(false));
          dispatch(setOffice(null));
          props.history.push(
            `/create-account/wiring-instructions?transfer_id=${transfer_id}&tenant_id=${check.tenant.link}`,
          );
        })
        .catch((err) => {
          toast.error(err.message);
          console.log(err, 'error');
        });
    } else {
      createTransfer({
        variables: { transfer: { ...check, status: 'awaiting wire' } },
      })
        .then(async (response) => {
          dispatch(
            saveTransferDetails({
              ...check,
              tenant: props.tenant,
              transferId: response.data.insertOneTransfer._id,
            }),
          );

          //email package
          // const data = {
          //   transfer: { ...check, name: 'Client Transfer', status: 'awaiting wire' },
          //   TRANSFER_GUID: response.data.createTransfer.id,
          // };
          //send email
          // const res = await emailFinancials(data);
          // console.log(res)
          //clear form state
          dispatch(saveTransferDetails({ ...check, tenant: props.tenant }));
          dispatch(setAmount(null));
          dispatch(setReAmount(null));
          dispatch(setCity(null));
          dispatch(setStateLocale(null));
          dispatch(setZip(null));
          dispatch(setStreet(null));
          dispatch(setStreet2(null));
          dispatch(setNotes(null));
          dispatch(setOffice(null));
          dispatch(setLoading(false));
          props.history.push(
            `/create-account/wiring-instructions?transfer_id=${response.data.insertOneTransfer._id}&tenant_id=${check.tenant.link}`,
          );
        })
        .catch((err) => {
          console.log(err);
          toast.error(err.message);
        });
    }
  }
}
